/** Configure Amplify once at startup using this build's environment settings.
 * Analytics stays disabled, matching the existing portal behaviour.
 */
import { Amplify } from 'aws-amplify';
import authConfig from './auth-config';

Amplify.configure({
  ...authConfig,
  Analytics: { disabled: true },
});
